/**
 * The opener line for Refine's talk hero + "your story" bubble — HIS 2026-07-20
 * WALK RECEIPT (NO INVENTION): the old static placeholder opener told an
 * EMPTY-corpus account "Hi — I just finished reading your resume, and there's
 * real substance here" — a fabricated claim about material that was never
 * given (the live agent immediately contradicted it: "the record is empty on
 * my end"). The opener is now chosen from the SAME served-corpus signal the
 * page's own view toggle already reads — never a canned claim.
 *
 * Pure + unit-pinned (refineOpener.test.ts) so the empty-corpus line can
 * never silently regress back to the invented one.
 */

export type CorpusOpenerState = 'loading' | 'empty' | 'has-content';

export function resolveCorpusOpenerState(
  loading: boolean,
  roleCount: number,
  achievementCount: number,
): CorpusOpenerState {
  if (loading) return 'loading';
  return roleCount > 0 || achievementCount > 0 ? 'has-content' : 'empty';
}

export function resolveOpenerLine(state: CorpusOpenerState): string {
  switch (state) {
    // True in every case — the corpus read is genuinely in flight.
    case 'loading':
      return "One sec — I'm checking what you've shared with me so far.";
    // The honest ask (his direction: "ask for it if empty") — no claim of
    // having read anything, and both doors (paste / just talk) stay open.
    case 'empty':
      return "I don't have your resume yet — paste it in below, or just tell me your first story. Either way, we start from what's real.";
    // Grounded: the corpus genuinely has served content behind this line.
    case 'has-content':
      return "I've been through what you've given me. Tell me about a moment at work you're proud of — even a small one. What comes to mind?";
  }
}
